import { Injectable } from '@angular/core';
import { AppState } from "../reducers";
import { MessageActions } from '../actions';
import { Store } from '@ngrx/store';

@Injectable()
export class WindowOpenService {
	constructor(
		private	store$: Store < AppState >,
		private	messageActions: MessageActions
	) {}

	public windowOpen(url: string, target: string) {
		let popupWindow = window.open(url, target);
		try {
			popupWindow.focus();
		} catch (e) {
			this.store$.dispatch(this.messageActions.displayMessage("Der Pop-up Blocker von Ihrem Browser ist aktiviert! Bitte fügen Sie diese Website " +
				"zu der Ausnahmeliste hinzu.", "error"))
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/services/window-open.service.ts